import { useMemo } from 'react';
import { IntegrationsDataList, IntegrationType } from '../Types';
import { IntegrationsList } from '../Consts';
import { usePricingModulesState } from '../../../context/contexts/PricingModuleContext';
import { useIsCloudOnly } from '../../SystemSettings/hooks/featureFlags/useIsCloudOnly';

export const getFilteredIntegrationsList = (
    isAnyModuleCloudEnabled: boolean,
    isCloudOnly: boolean
): IntegrationsDataList => {
    if (!isAnyModuleCloudEnabled) {
        return {
            [IntegrationType.onPrem]: IntegrationsList[IntegrationType.onPrem]
        };
    }

    if (isCloudOnly) {
        return Object.fromEntries(Object.entries(IntegrationsList).filter(([key]) => key !== IntegrationType.onPrem));
    }

    return IntegrationsList;
};

export const useFilteredIntegrations = (): IntegrationsDataList => {
    const { isAnyModuleCloudEnabled } = usePricingModulesState();
    const isCloudOnly = useIsCloudOnly();

    return useMemo(() => {
        return getFilteredIntegrationsList(isAnyModuleCloudEnabled, isCloudOnly);
    }, [isAnyModuleCloudEnabled, isCloudOnly]);
};
